import useSub from "@/components/layout/useSub";
import DODO_STATUS_TYPE from "@/constants/dodoStatusType";
import { useAuth } from "@/hooks/useAuth";
import { getUsage } from "@/utils/dodo";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function useBillingMeter(canFetch = true) {
  const {  org, user } = useAuth();
  const router = useRouter();
    const isAllowedToFetchSubscription =
    user?.id &&
    router.pathname !== "/organization" &&
    router.pathname !== "/on-board";

  const { subscriptionData: subscription } = useSub(isAllowedToFetchSubscription == true);
  const creditEventCount = useSelector(state => state.common.creditEventCount);
  
  const isTrial = () => {
    if (subscription?.attributes) {
      return subscription.attributes.dodo_status === DODO_STATUS_TYPE.trial;
    }
    return false;
  };

  const meterName = isTrial()
    ? process.env.NEXT_PUBLIC_TRIAL_METER_NAME
    : process.env.NEXT_PUBLIC_METER_NAME;


  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["billing-meter", creditEventCount],  
    queryFn: () => getUsage(meterName, org?.attributes?.customer?.id, subscription?.attributes?.dodo_subscription_id),
    enabled: (!!org?.attributes?.customer?.id && !!subscription?.attributes?.dodo_subscription_id && canFetch),
    cacheTime: 3600000, // 1 hour
    staleTime: 3600000, // 1 hour
  });
  return { data, isLoading, isError,refetch };
}
